import { Directive } from '@angular/core';

@Directive({
  selector: '[reset-scroll]'
})
export class ResetScrollDirective {

  /* using this directive in a component will reset the scroll to 0,0
  Whenever the compoenent (view) is initialised */

  constructor() {
    /* using window.. directly is to be avoided as per angular guidelines.
    Will have to be changed later using @HostListners */
    window.scroll(0, 0);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/directives/reset-scroll.directive.ts